import { render, staticRenderFns } from "./NewRenewalPolicy.vue?vue&type=template&id=31a1c192&"
import script from "./NewRenewalPolicy.vue?vue&type=script&lang=js&"
export * from "./NewRenewalPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports